import { api_GET } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";

export default function ValidaAcessoFuncionalidadeAcao(funcionalidadeAcao, callback){
    let session = getSessionCookie();  
    if (session == null)
    {
        callback(false);
        return;
    }
    
    if (session.login == "csj")
    {
        callback(true);
        return;
    }

    api_GET('usuario/ValidaAcessoFuncionalidadeAcao/' + session.usuario_Id + "/" + funcionalidadeAcao).then(result => {
        if (result.status === 200)        
            callback(result.data);
        else
            callback(false);
    });
};